import React, { RefObject } from "react";

/**
 * Defines a base error message container that simply needs to be passed
 * an error text in order to render it nicely.
 */
// tslint:disable-next-line variable-name
export const BaseError: React.FC<{
  ref?: RefObject<HTMLDivElement | null>;
  errorMessage: React.ReactNode;
}> = (props) => {
  return (
    <div ref={props.ref} className="error">
      <div className="icon-container">
        <div className="icon" />
      </div>
      <p className="text">{props.errorMessage}</p>

      <style jsx>{`
        .error {
          position: relative;

          /** Ensure content within is stacked vertically and centered horiontally */
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          flex: 1;

          & .icon-container {
            /** Setup spacing between icon and error text */
            margin-bottom: 30px;
          }

          & .icon {
            position: relative;

            /** Setup dimensions of error icon */
            width: 80px;
            height: 80px;

            /** Render circle of icon */
            border: 3px solid #dc4320;
            border-radius: 50%;

            &::before {
              /** Render the "!" within the icon circle */
              content: "!";
              color: #dc4320;
              font-size: 70px;
              font-weight: 700;
              line-height: 80px;

              /** Center icon within circle */
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }

          & .text {
            /** Override defaults */
            margin: 0;

            /** Setup font */
            text-align: center;
            font-size: 22px;
            line-height: 1.533;
          }
        }
      `}</style>
    </div>
  );
};
